import { render, staticRenderFns } from "./BasicOnetoOneAll.vue?vue&type=template&id=6b98a7a2&scoped=true"
import script from "./BasicOnetoOneAll.vue?vue&type=script&lang=js"
export * from "./BasicOnetoOneAll.vue?vue&type=script&lang=js"
import style0 from "./BasicOnetoOneAll.vue?vue&type=style&index=0&id=6b98a7a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b98a7a2",
  null
  
)

export default component.exports